'use strict';

angular.module('webAgro1App').filter('max', () => {
  return (items, field) => {
    if (!items || !field) {
      return;
    }
    const max = _.maxBy(items, field);
    return _.get(max, field);
  };
});
